import axiosCall from './interceptor';
import URL from '../helper';

export const getTemplate = async templateId => {
  let url = `${URL.BASE_URL}template/${templateId}?includePages=true`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const changeTemplate = async data => {
  let additionalParams = '';
  if (data.name) {
    additionalParams = `&name=${data.name}`;
  }
  const url = `${URL.BASE_URL}template?id=${data.id}&displayName=${data.displayName}${additionalParams}`;
  let response = await axiosCall('patch', url, data);
  return response.data;
};

export const deleteTemplate = async payload => {
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/document?id=${payload.id}`;
  let response = await axiosCall('delete', url);
  return response.data;
};

export const getSelectedTemplate = async data => {
  const url = `${URL.BASE_URL}template?ids=${data}&includePages=true `;
  let response = await axiosCall('get', url);
  return response.data;
};

export const getAllTemplate = async (categoryId, type, searchVal) => {
  const url = `${
    URL.DESIGN_SYSTEM_URL
  }dynamic/document?categoryId=${categoryId}&rgPermission=write&includeFlows=false&${searchVal &&
    `searchParam=${searchVal}`}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const getTemplateByCategory = async (page, type, name, tags, categoryIds, selectedLanguage) => {
  let url;
  let payload = {
    page,
    ...( selectedLanguage && selectedLanguage !== 'all' && { languages: selectedLanguage }),
  };
  if (name) {
    payload.name = name;
  }
  if (tags) {
    payload.tags = tags;
  }
  if (categoryIds) {
    payload.categoryIds = categoryIds;
  }
  const searchParam = new URLSearchParams(payload);
  url = `${
    URL.DESIGN_SYSTEM_URL
  }dynamic/document?limit=8&includeFlows=false&rgPermission=write&${searchParam.toString()}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const getTemplateStatus = async (id, lockType) => {
  const url = `${URL.BASE_URL}template/lockstatus?id=${id}&lockType=${lockType}`;
  let response = await axiosCall('post', url);
  return response.data;
};

export const getTemplateLockStatus = async (id, resourceType) => {
  const url = `${URL.BASE_URL}lockstatus/${resourceType}/${id}`;
  let response = await axiosCall('post', url);
  return response.data;
};

export const lockResource = async (id, resourceType) => {
  const url = `${URL.BASE_URL}lock/${resourceType}/${id}`;
  let response = await axiosCall('post', url);
  return response.data;
};

export const unlockTemplate = async (id, resourceType) => {
  const url = `${URL.BASE_URL}unlock/${resourceType}/${id}`;
  let response = await axiosCall('post', url);
  return response.data;
};

export const searchTemplates = async (payload, type, isPublished = false) => {
  const params = new URLSearchParams(payload);
  const statusUrl = isPublished ? 'publishedtemplate' : 'template';
  let url = `${URL.BASE_URL}${statusUrl}?includePages=true&includeVariables=true&${params}`;
  if (type) {
    url = `${URL.BASE_URL}${statusUrl}?includePages=true&includeVariables=true&type=${type}&${params}`;
  }
  if (isPublished) {
    url = `${URL.TRANSACTION_SYSTEM_URL}publishedDocuments?includeFlows=true&${params}`;
  }
  let response = await axiosCall('get', url);
  return response.data;
};

export const searchDocuments = async (payload, type, isPublished = false) => {
  const params = new URLSearchParams(payload);
  let url = `${URL.DESIGN_SYSTEM_URL}dynamic/document?${params}`;
  let response = await axiosCall('get', url);
  return response.data;
}

export const getAllPublishedtemplate = async payload => {
  const params = new URLSearchParams(payload);
  const url = `${URL.BASE_URL}publishedtemplate?includePages=true&includeVariables=true&${params}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const getAllPublishedDocuments = async payload => {
  const params = new URLSearchParams(payload);
  const url = `${URL.TRANSACTION_SYSTEM_URL}publishedDocuments?includeFlows=true&${params}`;
  let response = await axiosCall('get', url);
  return response.data;
};
